module.exports = __webpack_public_path__ + "img/placeholder-square.0afe633a.png";